import { useContext, useState } from 'react';
import "./Login.scss";
import { loginFields } from './LoginFields.js';
import { styles, labelStyles, inputStyles } from './LoginFieldStyles.js';
import { AppContext } from '../context/AppContext.jsx';
import { useNavigate } from 'react-router-dom';
import NI_Logo from "../../src/assets/Research/Logo.png";
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputText } from 'primereact/inputtext';

const Login = () => {
    const { loginData, handleChange, handleSubmit, loginValidationError } = useContext(AppContext);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    // Create a wrapper for handleSubmit to handle loading state
    const handleLoginSubmit = async (e) => {
        setIsLoading(true);
        try {
            await handleSubmit(e);
        } finally {
            setIsLoading(false);
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    // Custom input styles for login page only
    const loginInputStyles = {
        ...inputStyles,
        width: '100%'
    };

    return (
        <div className="loginPageMainContainer">
            <div>
                <img src={NI_Logo} alt="NI_Logo" width={150} height={165} />
            </div>

            <header style={{ display: "flex", justifyContent: "center" }}>
                <h2 className="">NOORUL ISLAM COLLEGE OF ARTS & SCIENCE</h2>
            </header>

            <form action="" className="loginForm" onSubmit={handleLoginSubmit}>
                {loginFields.map((field, index) => (
                    <div key={index} style={styles}>
                        <label
                            htmlFor={field.fieldName}
                            style={labelStyles}
                            className="label"
                        >
                            {field.customLabelName}
                        </label>

                        {field.type === 'password' ? (
                            <div className="password-input-wrapper" style={{ position: 'relative' }}>
                                <InputText
                                    id={field.fieldName}
                                    name={field.fieldName}
                                    type={showPassword ? 'text' : 'password'}
                                    value={loginData[field.fieldName]}
                                    onChange={(e) => handleChange(field.fieldName, e.target.value)}
                                    placeholder={field.placeholder}
                                    style={{
                                        ...loginInputStyles,
                                        paddingRight: '2.5rem'
                                    }}
                                    required={field.required}
                                    className={loginValidationError?.[field.fieldName] ? 'p-invalid' : ''}
                                />
                                <button
                                    type="button"
                                    className="password-toggle-btn"
                                    onClick={togglePasswordVisibility}
                                    tabIndex={-1}
                                    style={{
                                        position: 'absolute',
                                        right: '12px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        background: 'none',
                                        border: 'none',
                                        cursor: 'pointer',
                                        color: '#6c757d',
                                        fontSize: '1.2rem',
                                        padding: '0.25rem',
                                        borderRadius: '50%',
                                        transition: 'background-color 0.2s'
                                    }}
                                    onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                                    onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                                >
                                    <i className={showPassword ? "pi pi-eye" : "pi pi-eye-slash"} />
                                </button>
                            </div>
                        ) : (
                            <InputText
                                id={field.fieldName}
                                name={field.fieldName}
                                type={field.type}
                                value={loginData[field.fieldName]}
                                onChange={(e) => handleChange(field.fieldName, e.target.value)}
                                placeholder={field.placeholder}
                                style={loginInputStyles}
                                required={field.required}
                                className={loginValidationError?.[field.fieldName] ? 'p-invalid' : ''}
                            />
                        )}

                        {loginValidationError?.[field.fieldName] && (
                            <p style={{
                                color: "red",
                                fontSize: "16.5px",
                                marginTop: "6px",
                                fontFamily: "var(--font-paragraph)",
                                marginBottom: 0
                            }}>
                                {loginValidationError[field.fieldName]}
                            </p>
                        )}
                    </div>
                ))}

                <div className="forgetPasswordParent">
                    <p className="forgetPassword" onClick={() => navigate("/reset-password")}>Forget Password?</p>
                </div>

                <div>
                    <button
                        className="loginBtn"
                        disabled={isLoading}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px',
                            width: '100%',
                            opacity: isLoading ? 0.7 : 1,
                            cursor: isLoading ? 'not-allowed' : 'pointer'
                        }}
                    >
                        {isLoading ? (
                            <>
                                <ProgressSpinner
                                    style={{ width: '20px', height: '20px' }}
                                    strokeWidth="4"
                                />
                                <span style={{ color: "white" }}>LOGGING IN...</span>
                            </>
                        ) : (
                            'LOGIN'
                        )}
                    </button>
                </div>
            </form>
        </div>
    )
}

export default Login;